import React from 'react'
import styled from "styled-components"

import PropTypes from 'prop-types'

import { colors } from '../style/vars';



const Button = ({ children, onClick }) => (
  <ButtonWrapper>
    <button onClick={onClick}>
      {children}
    </button>
  </ButtonWrapper>
)



const ButtonWrapper = styled.span`
  background: ${colors.brandPrimary};
  background: -webkit-linear-gradient(right, rgb(187, 160, 117) 0%, rgb(215, 192, 151) 60%, rgb(189, 162, 119) 80%, rgb(206, 180, 143) 100%) ${colors.brandPrimary};
  background: -o-linear-gradient(right, rgb(187, 160, 117) 0%, rgb(215, 192, 151) 60%, rgb(189, 162, 119) 80%, rgb(206, 180, 143) 100%) ${colors.brandPrimary};
  background: -ms-linear-gradient(right, rgb(187, 160, 117) 0%, rgb(215, 192, 151) 60%, rgb(189, 162, 119) 80%, rgb(206, 180, 143) 100%) ${colors.brandPrimary};
  background: -moz-linear-gradient(right, rgb(187, 160, 117) 0%, rgb(215, 192, 151) 60%, rgb(189, 162, 119) 80%, rgb(206, 180, 143) 100%) ${colors.brandPrimary};
  background: linear-gradient(to left, rgb(187, 160, 117) 0%, rgb(215, 192, 151) 60%, rgb(189, 162, 119) 80%, rgb(206, 180, 143) 100%) ${colors.brandPrimary};
  color: #fff;
  cursor: pointer;
  display: inline-block;
  transition: 0.3s background, 0.3s color;

  &:hover {
    background: #000;
    color: ${colors.brandPrimary};
  }

  button {
    background: none;
    color: inherit;
    cursor: pointer;
    font-size: 1.1rem;
    font-weight: bold;
    text-transform: uppercase;
    height: 3rem;
    width: 16rem;
  }
`



Button.propTypes = {
  /**
   * 'children' Prop
   * Content of button.
   *
   * @example 'Enquire Now'
   */
  children: PropTypes.node.isRequired,

  /**
   * 'onClick' Prop
   * Function to run when clicking.
   * 
   * @example function() {} 
   */
  onClick: PropTypes.func.isRequired,
}



export default Button
